import DoneIcon from '@mui/icons-material/Done'
import { styled } from '@mui/material'
import { Flex, FlexColumn } from 'styles'

export const TriggerDone = styled(DoneIcon)`
  color: ${(props) => props.theme.color.notificationGreen02};
  font-size: 12px;
`

export const StyledColumn = styled(FlexColumn)`
  align-items: flex-start;
  .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.color?.text90};
    text-align: right;
  }
  .sub {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: ${(props) => props.theme.color?.text60};
  }
`

export const SymbolLink = styled(Flex)`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    display: none;
  }
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    svg {
      margin-left: 2px;
      display: block;
    }
  }
`

export const StyledEndItem = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

export const CoinIcon = styled(Flex)`
  img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin-right: 8px;
  }
`
export const CoinData = styled(FlexColumn)``
export const CoinSize = styled(Flex)`
  align-items: flex-end;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 2px;
  &.buy {
    color: ${(props) => props.theme.color.buy30};
  }
  &.sell {
    color: ${(props) => props.theme.color.sell30};
  }

  small {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    margin-left: 2px;
    color: ${(props) => props.theme.color.text40};
  }
`
export const CoinName = styled(Flex)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.color.text60};
`
